import { useEffect, useState } from 'react';
import {
  Button,
  FormHelperText,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
  IconButton,
  TextField,
  Card,
  Container
} from '@mui/material';

import * as Yup from 'yup';
import { Formik } from 'formik';
import { useNotify } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import { changePasswordGraphql } from '../../services/ChangePassword';
import {
  Visibility,
  VisibilityOff,
  Save,
  KeyboardBackspace,
} from '@mui/icons-material';
import FontSize from '../layout/FontSize';
import Color from '../layout/color/Color';

// ============================|| CHANGE PASSWORD ||============================ //


const saveButton = {
  bgcolor: Color.Main,
  borderRadius: '30px',
  border: '1px solid #ccc',
  fontWeight: '500',
  textAlign: 'center',
  color: Color.Button,
  padding: '8px 15px',
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Button, color: Color.Normal }
};

const backButton = {
  bgcolor: Color.Button,
  borderRadius: '30px',
  border: "1px solid #055C2D",
  color: Color.Main,
  fontWeight: '500',
  textAlign: 'center',
  padding: '8px 15px',
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Main, color: Color.Button }
};
const ChangePassword = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showNewRePassword, setShowNewRePassword] = useState(false);

  const notify = useNotify();
  let navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('userToken') === null) {
      navigate('/#/login', { replace: true });
    }
  });

  const handleShowOldPassword = () => {
    setShowOldPassword(!showOldPassword);
  };

  const handleShowNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  };

  const handleShowNewRePassword = () => {
    setShowNewRePassword(!showNewRePassword);
  };

  const handleBack = (e) => {
    e.preventDefault();
    navigate('/dashboard');
  };

  return (
    <Container maxWidth="md"
      sx={{
        ml: '0px',
        mr: '16px',
        position: 'relative',
        left: '50%',
        top: '45%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <Card
        sx={{ justifyContent: 'center', py: 2, pr: 3, pl: 2 }}
      >

        <Container maxWidth="sm">
          <Typography
            variant="h3"
            sx={{ mb: 2, pt: 2, color: Color.Main }}
            textAlign="center"
          >
            Change Password
          </Typography>
          <Typography variant="h5" sx={{ color: Color.Main }} textAlign="center">
            Fill out the following informations.
          </Typography>
          <Formik
            initialValues={{
              password: '',
              newPassword: '',
              reTypeNewPassword: '',
              submit: null,
            }}
            validationSchema={Yup.object().shape({
              password: Yup.string(),
              newPassword: Yup.string().min(
                6,
                'Password is too short - should be 6 chars minimum.'
              ),
              reTypeNewPassword: Yup.string().when('newPassword', {
                is: (val) => (val && val.length > 0 ? true : false),
                then: Yup.string().oneOf(
                  [Yup.ref('newPassword')],
                  'Both password need to be the same'
                ),
              }),
            })}
            onSubmit={async (
              values,
              { setErrors, setStatus, setSubmitting, resetForm }
            ) => {
              try {
                const data = {
                  oldPass: values.password,
                  newPass: values.newPassword,
                };
                setStatus({ success: false });
                setSubmitting(false);
                changePasswordGraphql(data)
                  .then((result) => {
                    if (result !== null) {
                      resetForm({
                        values: {
                          password: '',
                          newPassword: '',
                          reTypeNewPassword: '',
                        },
                      });
                      notify('Your password has been changed successfully!', {
                        type: 'success',
                      });
                    }
                  })
                  .catch((err) => {
                    notify('An error occurred, Please try later!', {
                      type: 'error',
                    });
                  });
              } catch (err) {
                setStatus({ success: false });
                setErrors({ submit: err.message });
                setSubmitting(false);
              }
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values,
            }) => (
              <form noValidate onSubmit={handleSubmit}>
                <Grid
                  container
                  spacing={6}
                  mt="0.5rem"
                >
                  <Grid container item>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        autoComplete="current-password"
                        variant="outlined"
                        error={Boolean(touched.password && errors.password)}
                        id="password"
                        type={showOldPassword ? 'text' : 'password'}
                        value={values.password}
                        name="password"
                        onBlur={handleBlur}
                        label="Old Password"
                        required
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        InputProps={{
                          endAdornment: (
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleShowOldPassword}
                              edge="end"
                              size={isMd ? 'small' : 'medium'}
                            >
                              {showOldPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          ),
                        }}
                      />
                    </Grid>
                    {touched.password && errors.password && (
                      <FormHelperText error id="helper-text-password-signup">
                        {errors.password}
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid container item>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        autoComplete="new-password"
                        variant="outlined"
                        error={Boolean(
                          touched.newPassword && errors.newPassword
                        )}
                        id="new-password"
                        type={showNewPassword ? 'text' : 'password'}
                        value={values.newPassword}
                        name="newPassword"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        label="New Pasword"
                        required
                        InputProps={{
                          endAdornment: (
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleShowNewPassword}
                              edge="end"
                              size={isMd ? 'small' : 'medium'}
                            >
                              {showNewPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          ),
                        }}
                      />
                    </Grid>
                    {touched.newPassword && errors.newPassword && (
                      <FormHelperText error id="helper-text-password-signup">
                        {errors.newPassword}
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid container item>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        autoComplete="new-password"
                        variant="outlined"
                        error={Boolean(
                          touched.reTypeNewPassword &&
                          errors.reTypeNewPassword
                        )}
                        id="reTypeNewPassword"
                        type={showNewRePassword ? 'text' : 'password'}
                        value={values.reTypeNewPassword}
                        name="reTypeNewPassword"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        label="Re-type New Password"
                        required
                        InputProps={{
                          endAdornment: (
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleShowNewRePassword}
                              edge="end"
                              size={isMd ? 'small' : 'medium'}
                            >
                              {showNewRePassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          ),
                        }}
                      />
                    </Grid>
                    {touched.reTypeNewPassword && errors.reTypeNewPassword && (
                      <FormHelperText error id="helper-text-password-signup">
                        {errors.reTypeNewPassword}
                      </FormHelperText>
                    )}
                  </Grid>
                  {errors.submit && (
                    <Grid item xs={12}>
                      <FormHelperText error>{errors.submit}</FormHelperText>
                    </Grid>
                  )}
                  <Grid
                    container
                    item
                    sx={{
                      textAlign: 'center',
                      mb: 3,
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Grid item xs={6} sm={6}>
                      <Button
                        onClick={handleBack}
                        type="button"
                        sx={backButton}
                        startIcon={<KeyboardBackspace />}
                      >
                        Back
                      </Button>
                    </Grid>
                    <Grid item xs={6} sm={6}>
                      <Button
                        disabled={isSubmitting}
                        type="submit"
                        startIcon={<Save />}
                        sx={saveButton}                      >
                        Save
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
        </Container>
      </Card>
    </Container>
  );
};

export default ChangePassword;
